import { useContext } from "react";
import SiteContext from "site/SiteContext";

const envir = process.env.REACT_APP_COLLECTION_ENV;
const baseImageURL = process.env.REACT_APP_IMAGE_BASE_PATH;
const baseCollectionURL = process.env.REACT_APP_COLLECTION_BASE_PATH;

// Maybe use imageOptions instead of imageSize/type etc.
export const buildIIIFImageURL = (objectID, imageID, imageOptions={}) => {

    // second half needs rework    
    const size = imageOptions.size == 'full' ? 'full' : imageOptions.size + ',';
    const type = imageOptions.type ? imageOptions.type : 'full';

    return `${baseImageURL}${envir}__objects__${objectID}__${imageID}__image.jpg/${type}/${size}/0/default.jpg`;
};

export const buildIIIFInfoURL = (objectID, imageID) => {
    return `${baseImageURL}${envir}__objects__${objectID}__${imageID}__pyramid.jp2/info.json`;
};

// Image URL against the high-resolution pyramid.jp2 source rather than the default jpg.
// `size` is passed through as a raw IIIF size parameter (e.g. 'full', '5000,', ',5000').
export const buildIIIFPyramidImageURL = (objectID, imageID, imageOptions={}) => {
    const size = imageOptions.size || 'full';
    const type = imageOptions.type ? imageOptions.type : 'full';

    return `${baseImageURL}${envir}__objects__${objectID}__${imageID}__pyramid.jp2/${type}/${size}/0/default.jpg`;
};

// Resolves to a pyramid.jp2 image URL at the largest size the server advertises
// in the info.json `sizes` array. The server caps requests at a maximum pixel
// count, so we never ask for `full` or an arbitrary dimension.
export const fetchIIIFDownloadURL = async (objectID, imageID) => {
    const response = await fetch(buildIIIFInfoURL(objectID, imageID));
    if (!response.ok)
        throw new Error(`Unable to load IIIF info for ${objectID}/${imageID}: ${response.status}`);

    const info = await response.json();
    const sizes = Array.isArray(info.sizes) ? info.sizes.filter(s => s.width && s.height) : [];
    if (sizes.length === 0)
        throw new Error(`IIIF info for ${objectID}/${imageID} has no sizes array`);

    const largest = sizes.reduce((best, s) => (s.width * s.height > best.width * best.height) ? s : best);

    return buildIIIFPyramidImageURL(objectID, imageID, { size: `${largest.width},${largest.height}` });
};

export const buildObjectManifestURL = ({ objectID }) => {
    const { languagePath } = useContext(SiteContext);

    // Hacky work-around to gardener not placing english content in a en folder
    // will fix this
    const lp = (languagePath == '/en') ? '' : languagePath;

    return `${baseCollectionURL}${envir}/objects/${objectID}${lp}/object.json`;
};

export const buildIIIFManifestURL = ( objectID ) => {
    const { languagePath } = useContext(SiteContext);

    // Hacky work-around to gardener not placing english content in a en folder
    // will fix this
    const lp = (languagePath == '/en') ? '' : languagePath;

    return `${baseCollectionURL}${envir}/objects/${objectID}${lp}/manifest.json`;
};